import Title from "antd/lib/typography/Title"
import { SizeSelector } from "./SizeSelector"
import { Select } from "antd"
import { TempLineType, getFlowTemplate, updateTemplate } from "@/store/flowsheet/flowsheet.slice"
import { useDispatch, useSelector } from "react-redux"

export const TemplateSetting = () => {
  const template = useSelector(getFlowTemplate)
  const dispatch = useDispatch()

  const onSelectLine = (val) => {
    dispatch(updateTemplate({border: val}))
  }

  return <div>
    <div style={{borderBottom: '1px solid #aaa'}}>
      <Title level={3}>Template Setting</Title>
    </div>
    <div className="p-1">
      <Title level={5}>Size</Title>
      <SizeSelector />
      <Title level={5}>Border</Title>
      <Select
        className="mt-1"
        value={template?.border}
        style={{width: '100%'}}
        onChange={onSelectLine}
      >
        <Select.Option key='none' value={TempLineType.None}>None</Select.Option>
        <Select.Option key='solid' value={TempLineType.Solid}>
          <div style={{borderTop: '2px solid #000'}} className="mt-1"></div>
        </Select.Option>
        <Select.Option key='dash' value={TempLineType.Dashed}>
          <div style={{borderTop: '2px dashed #000'}} className="mt-1"></div>
        </Select.Option>
      </Select>
      {/* <div className="mt-1">
        <div className="flex-space-btw">
          <Title level={5}>Table</Title>
          <div><Button type='text' icon={<PlusOutlined />}>Add</Button></div>
        </div>
      </div> */}
    </div>
    
  </div>
}